export default {
	name: 'EmptyItem',
	props: {
		text: {
			type: String,
			default: 'Nada aqui.',
		},
		classP: {
			type: String,
			default: '',
		},
		icons: {
			type: Array,
			default: () => ['fluorescent', 'spa', 'light'],
		},
	},
	data() {
		return {
			randomIndex: Math.floor(Math.random() * this.icons.length),
		}
	},
	computed: {
		iconName() {
			return this.icons[this.randomIndex]
		},
	},
    mounted() {
        
    },
	template: `
        <div class="text-paragraph-2 text-center m-auto !h-full flex-1 flex flex-col justify-center">
            <q-icon
                class="block mx-auto opacity-30 "
                :name="iconName"
                size="2.5rem"
                :class="classP"
            ></q-icon>
            <p class="opacity-40 " :class="classP">{{ text }}</p>
        </div>
    `,
}
